export default "__VITE_ASSET__B_hC5i6q__"